import { useEffect } from 'react';

import { NumberPatternType } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import { MedicineRawMaterialTableBean } from './MedicineRawMaterialTable.types';

type QuantityNumberInputCellProps = InteractiveTableCellProps<number | null>;

const MIN_VALUE = 0.001;
const STEP_VALUE = 0.01;
const MAX_VALUE = 9999999.9999;
const DECIMAL_PLACES = 4;

export const QuantityNumberInputCell = (props: QuantityNumberInputCellProps): JSX.Element => {
   const { getCellValue, triggerCell } = useInteractiveTableContext<MedicineRawMaterialTableBean>();

   const currentQuantity = getCellValue('quantity', props.index);
   useEffect(() => {
      triggerCell('unit');
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentQuantity]);

   const rpw = getCellValue('rpw', props.index);

   return (
      <InteractiveTable.NumberInputCell
         testId={props.testId}
         name={props.name}
         index={props.index}
         validationRules={{
            required: rpw,
         }}
         pattern={NumberPatternType.POSITIVE_FLOAT}
         precision={DECIMAL_PLACES}
         defaultValue={props.defaultValue}
         stepValue={STEP_VALUE}
         min={MIN_VALUE}
         max={MAX_VALUE}
         enableControlButtons
      />
   );
};
